import config from "@Config/index";
import { isRegionalBlogLanguage, type RegionalBlogLanguage } from "./blogLanguage";

export type { RegionalBlogLanguage };

const CHINA_PREFIXED_COLLECTIONS = ["blog-posts", "categories", "blogs-home-featured-limited"];

const LANGUAGE_PREFIXED_COLLECTIONS = [
  "blog-posts",
  "categories",
  "tags",
  "countries",
  "blogs-home-featured-limited",
];

const SHARED_COLLECTIONS = ["blog-partners"];

const getBlogCollectionUrl = (collection: string, lang?: RegionalBlogLanguage): string => {
  // Shared collections never get prefixed
  if (SHARED_COLLECTIONS.includes(collection)) {
    return `${config.CMS_API_URL}/api/${collection}`;
  }

  // China app always uses china- prefix
  if (config.IS_CHINA_APP && CHINA_PREFIXED_COLLECTIONS.includes(collection)) {
    return `${config.CMS_API_URL}/api/china-${collection}`;
  }

  if (isRegionalBlogLanguage(lang) && LANGUAGE_PREFIXED_COLLECTIONS.includes(collection)) {
    return `${config.CMS_API_URL}/api/${lang}-${collection}`;
  }

  // Default: English (no prefix)
  return `${config.CMS_API_URL}/api/${collection}`;
};

export default getBlogCollectionUrl;
